module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    attrs: {
      "src": _vm.imgSrc,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showBtn),
      expression: "showBtn"
    }],
    staticClass: "can-see"
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.print()
      }
    }
  }, [_vm._v("打印")]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.close()
      }
    }
  }, [_vm._v("关闭")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-9b59051e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/printImg.vue
// module id = 1022
// module chunks = 2